// eslint-disable-next-line import/prefer-default-export
export const CREATE_SESSION_FEEDBACK = 'CREATE_SESSION_FEEDBACK';
